import React from 'react';

import { Accordion } from '@zillow/constellation';

import { VIEW_TYPE } from './constants';

type WizardTipProps = {
  header?: string | null;
  viewType: string;
  children: React.ReactNode;
};
const WizardTip = ({ header = null, viewType = VIEW_TYPE.ACCORDION, children }: WizardTipProps) => {
  const renderAccordion = () => {
    return (
      <Accordion>
        <Accordion.Item>
          <Accordion.Header>{header}</Accordion.Header>
          <Accordion.Panel>{children}</Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    );
  };

  const renderCard = () => {
    return <>{children}</>;
  };

  return <div data-testid="WizardTip">{viewType === VIEW_TYPE.ACCORDION ? renderAccordion() : renderCard()}</div>;
};

export default WizardTip;
